/** Route guard: shows a spinner while bootstrapping, redirects if unauthenticated. */

import type { ReactNode } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Spinner } from "@pbxmgr/ui";

import { useAuth } from "../auth/AuthProvider";

/** Renders child routes only for an authenticated session. */
export function RequireAuth(): ReactNode {
  const { session, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="ops-center">
        <Spinner />
      </div>
    );
  }
  // Carry the interrupted route so login can return the user to it.
  if (!session) return <Navigate to="/login" replace state={{ from: location }} />;
  return <Outlet />;
}
